module.exports = __webpack_public_path__ + "img/garnelen-cutted.9e0aa924.png";